import { Error } from "@/components/admin/error";
import { Notification } from "@/components/admin/notification";
import { Skeleton } from "@/components/ui/skeleton";
import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { matchPath, useLocation } from "react-router";

import { DataImportProvider } from "../dataImport/DataImportProvider";
import { BriefReminder } from "../gula/brief/BriefReminder";
import { NewLeadAlerts } from "../gula/callPlan/NewLeadAlerts";
import { CallResultSheet } from "../gula/mobile/CallResultSheet";
import { GulaMobileNavigation } from "../gula/mobile/GulaMobileNavigation";
import { useConfigurationLoader } from "../root/useConfigurationLoader";
import { PullToRefresh } from "./PullToRefresh";

// Pages from Atomic CRM that bring their own mobile header and margins
const ATOMIC_MOBILE_PAGES = [
  "/contacts/*",
  "/companies/*",
  "/tasks/*",
  "/settings/*",
  "/changelog",
];

export const MobileLayout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  const location = useLocation();
  const ownLayout = ATOMIC_MOBILE_PAGES.some((pattern) =>
    matchPath(pattern, location.pathname),
  );
  const content = (
    <ErrorBoundary FallbackComponent={Error}>
      <Suspense fallback={<Skeleton className="h-12 w-12 rounded-full" />}>
        {children}
      </Suspense>
    </ErrorBoundary>
  );
  return (
    <DataImportProvider>
      <PullToRefresh />
      {ownLayout ? (
        content
      ) : (
        // The Gula pages (Jornada, Clientes, WhatsApp…) on the phone
        <main id="main-content" className="min-h-dvh px-3 pb-28 pt-2">
          <BriefReminder />
          {content}
        </main>
      )}
      <GulaMobileNavigation />
      <NewLeadAlerts />
      <CallResultSheet />
      <Notification mobileOffset={{ bottom: "88px" }} />
    </DataImportProvider>
  );
};
